



















import { Component } from "vue-property-decorator";
import CallActionsComponent from "@/app/components/call/components/callActions.component.vue";
import CallHeaderComponent from "@/app/components/call/components/callHeader.component.vue";
import CallContentComponent from "@/app/components/call/components/callContent.component.vue";
import { mixins } from "vue-class-component";
import Chime from "@/resources/mixins/chime/chime";
import CallEvents from "@/resources/mixins/notifications/callEvents";
import MoreActionsMenuComponent from "@/app/components/call/components/moreActionsMenu.component.vue";
import FloatMenuAnimation from "@/resources/mixins/animations/floatMenuAnimation";
import UsersInCallComponent from "@/app/components/call/components/usersInCall.component.vue";
import AudioMenuComponent from "@/app/components/call/components/audioMenu.component.vue";
import VideoMenuComponent from "@/app/components/call/components/videoMenu.component.vue";
import feather from "feather-icons";
@Component({
  name: "call-component",
  components: {
    VideoMenuComponent,
    AudioMenuComponent,
    UsersInCallComponent,
    MoreActionsMenuComponent,
    CallContentComponent,
    CallHeaderComponent,
    CallActionsComponent,
  },
})
export default class CallComponent extends mixins(
  Chime,
  CallEvents,
  FloatMenuAnimation
) {
  expand = false;
  constructor() {
    super();
    this.createMeeting();
    this.onCameraOrSoundDisabled();
  }
  mounted() {
    feather.replace();
    window.addEventListener("resize", () => {
      setTimeout(() => {
        this.onDisplayModeChange();
      }, 1000);
    });
    this.$store.dispatch(
      "MeetingStore/setFocusModeAction",
      localStorage.getItem("focusMode") === "true"
    );

    const element = document.getElementsByClassName("open-menu-container")[0];
    if (element) element["style"].left = "-23rem";
    setTimeout(() => {
      this.$store.dispatch("SidebarStore/setActiveMenuAction", -1);
    }, 500);
    /*  setTimeout(() => {
      this.$store.dispatch("GraphicClientStore/resizeGraphicClientAction");
    }, 1200); */
  }

  destroyed() {
    this.$store.dispatch("MeetingStore/closeMeetingSession");
    this.$store.dispatch("SidebarStore/setSidebarFullAction", true);
    this.$store.dispatch("MeetingStore/setPressToTalkEnabledAction", false);
    this.$store.dispatch("MeetingStore/setUsersInCallAction", []);
    this.$store.dispatch("MeetingStore/setCallIsRecordAction", false);
    this.closeRecordOptions();
    this.closeDeviceNotification();
    const tooltip = document.getElementsByClassName("vs-tooltip");
    if (tooltip)
      while (tooltip.length > 0) {
        tooltip[0].parentNode.removeChild(tooltip[0]);
      }
    setTimeout(() => {
      this.$store.dispatch("GraphicClientStore/resizeGraphicClientAction");
    }, 20);
  }

  get layoutType() {
    return this.$store.getters["MeetingStore/getLayoutType"];
  }

  /* onDisplayChange() {
    setTimeout(() => {
      this.onDisplayModeChange();
      this.$store.dispatch("GraphicClientStore/resizeGraphicClientAction");
    }, 20);
  } */
}
